// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { mergeWithCss } from "@hardwoods/XDL/Utilities/mergeWithCss";
import { quickOrderPageContainerStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderPageContainer";
import { css } from "styled-components";

quickOrderPageContainerStyles.innerContainer = {
    gap: 0,
};

quickOrderPageContainerStyles.rightColumnGridItem = {
    ...mergeWithCss(quickOrderPageContainerStyles.rightColumnGridItem, {
        css: css`
            display: flex;
            align-items: center;
        `,
    }),
};

quickOrderPageContainerStyles.bottomGridItem = {
    ...mergeWithCss(quickOrderPageContainerStyles.bottomGridItem, {
        css: css`
            .cartLine-actions {
                ${xScreen.lte("xs")} {
                    justify-content: flex-end;
                }
            }
        `,
    }),
};
